import apiClient from "./config";
import { LIFE_INSURANCE_ENDPOINTS } from "./endpoints";

const lifeInsuranceService = {
  lifeInsurance: (data) => {
    return apiClient.post(LIFE_INSURANCE_ENDPOINTS.lifeInsurance, data);
  },
  // DownloadlifeInsurancePDF: (data) => {
  //     return apiClient.post(LIFE_INSURANCE_ENDPOINTS.DownloadlifeInsurancePDF, data)
  // },
  DownloadlifeInsurancePDF: (data) => {
    return apiClient.post(
      LIFE_INSURANCE_ENDPOINTS.DownloadlifeInsurancePDF,
      data,
      {
        responseType: "blob", // <-- Add this!
      }
    );
  },
  calculatorAnalytics: (data) => {
    return apiClient.post(LIFE_INSURANCE_ENDPOINTS.calculatorAnalytics, data);
  },
};

export default lifeInsuranceService;
